<template lang="pug">
.info-section(:class="sectionClass")
  //- 错误提示
  .error-container(v-if="error")
    .error-message {{ error }}
    button.retry-button(@click="fetchUserData") 重新获取

  //- 主要内容
  .info-list(v-else)
    // 动态生成所有信息项
    .info-item(v-for="(item, key) in sectionData", :key="key")
      .item-label {{ item.name || key }}
      .item-content
        .collection-info
          .info-row
            .info-label 收集场景
            .info-value {{ item.collectScene || '-' }}
          .info-row
            .info-label 收集主体
            .info-value {{ item.collectBy || '-' }}
          .info-row
            .info-label 收集说明
            .info-value {{ item.collectInfo || '-' }}
          .info-row
            .info-label 信息内容
            .info-value(
              :class="{ clickable: item.jumpUrl }"
              @click="item.jumpUrl && navigateTo(item)"
            )
              | {{ item.infoContent || '-' }}
              span.navigate-icon(v-if="item.jumpUrl")
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import { setTitle } from '@/utils';
import { getComponentData } from '../js/getInfoCollection.js';

export default {
  name: 'InfoSection',
  props: {
    // 信息类型：personalInfoCollectionList, identityInfo, locationInfo, usageRecords, additionalService
    sectionType: {
      type: String,
      required: true,
    },
    // 自定义样式类
    customClass: {
      type: String,
      default: '',
    },
    // 自定义底部提示
    customTips: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 页面数据
      sectionData: {},
      // 错误信息
      error: '',
    };
  },
  computed: {
    // 根据sectionType生成对应的CSS类
    sectionClass() {
      const classMap = {
        basicInfo: 'user-basic-info',
        identityInfo: 'user-identity-info',
        locationInfo: 'user-location-info',
        usageRecords: 'user-usage-records',
        additionalService: 'additional-services',
      };
      return [classMap[this.sectionType] || 'info-section', this.customClass];
    },
  },
  created() {
    setTitle(this.$route.query.title || '个人信息收集清单');
    this.fetchUserData();
  },
  methods: {
    // 获取用户数据
    fetchUserData() {
      this.error = '';
      try {
        // 从统一的数据源获取组件所需数据
        this.sectionData = getComponentData(this.sectionType);

        if (Object.keys(this.sectionData).length === 0) {
          throw new Error('未获取到数据');
        }
      } catch (err) {
        this.error = `获取${this.sectionType}数据失败，请稍后重试`;
      }
    },

    // 导航到其他页面
    navigateTo(item) {
      if (item.jumpUrl) {
        jumpUrl(item.jumpUrl);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../style/common.less';
@import '../style/usage-records.less';
</style>
